import type { NextPageContext } from 'next';
import type { Scope } from '@sentry/hub';

/**
 * Do the reporting
 */
export function executeReport(
  {
    configureScope,
    captureExceptionSentry,
  }: { configureScope: ConfigScope; captureExceptionSentry: CaptureExceptionSentry },
  err: Error,
  ctx?: NextPageContext,
  instructions?: Instruction[]
) {
  // eslint-disable-next-line prefer-rest-params
  if (configureScope && captureExceptionSentry) {
    configureScope((scope) => {
      if (err.message) {
        scope.setFingerprint([err.message]);
      }

      if (ctx) {
        const { query, pathname } = ctx;
        if (typeof window !== 'undefined') {
          scope.setTag('ssr', 'false');
          scope.setExtra('query', query);
          scope.setExtra('pathname', pathname);
        }
      }

      if (instructions) {
        instructions.forEach((one) => {
          scope[one[0]](...one.slice(1));
        });
      }
    });

    return captureExceptionSentry(err);
  }
}

export type Instruction = [functionName: string, ...args: unknown[]];
export type ConfigScope = ((callback: (scope: Scope) => void) => void) | undefined;
// eslint-disable-next-line
export type CaptureExceptionSentry = ((exception: any) => string) | undefined;
